import { useLocalStorage } from '@mantine/hooks'

export const useIsFilledSurvey = (surveyId: string) => {
  const [isFilledSurvey, setIsFilledSurvey] = useLocalStorage<boolean>({
    key: `survey-${surveyId}`,
    defaultValue: false,
  })

  return [isFilledSurvey, setIsFilledSurvey] as const
}
